(function () {
'use strict';

angular
    .module('boxTemplateModule')
    .constant('boxTmplScope', {
        boxModel: '=?',
        boxModelAsync: '&',
        boxContext: '=?',
        boxTmplTitle: '=?',
        boxClick: '&',
        boxItemClick: '&',
        boxBackToList: '&',
        boxBackToListShow: '&',
        boxNoContainer: '=?',
        boxNoBox: '=?',
        boxIsSection: '=?',
        boxRefresh: '&',

        // Override logic based on permissions when clicking on an item
        boxClickable: '@',

        // Name of the permission to use instead of the default one when clicking on an item: 'View'
        boxClickablePermission: '@',

        // Name of the permission to use instead of the default one to display the box: 'View'
        boxIfPermission: '@',

        // Model to use for contextual permissions, instead of boxModel
        boxModelPermission: '=?',

        boxActive: '@',

        // FeatureRole to override instead of the default provided by each directive
        boxFeatureRole: '=?',

        // Key to use for contextual permissions instead of default set by each directive (i.e. 'ActionPlan', 'Control')
        boxPermissionKey: '=?'
    })
    .constant('boxTmplHtml',
              '<div ng-if="isBoxDisplayed" ng-include="getTemplateUrl()"></div>'
    )
    .constant('boxTmplLinkFn', function (scope, elem, attrs) {
        if (_.isUndefined(scope.boxModel)) {
            var asyncCall = scope.boxModelAsync();

            // TODO: Make sure this call is not made if user does not have the permissions to view the box

            if (!_.isUndefined(asyncCall)) {
                asyncCall.then(function (response) {
                    scope.boxModel = response;

                    if (_.isUndefined(scope.boxModel)) scope.boxModel = {};

                    return scope.refreshBoxPermissions();
                });
            }
        }

        scope.getTemplateUrl = function () {
            return scope.getInternalTemplateUrl(attrs);
        };

        scope.clickOnItem = function (item) {
            scope.confirmClick(scope.boxItemClick, {item: item});
        };

        scope.clickOnBox = function (arg) {
            if (!scope.isBoxClickable) return;

            scope.confirmClick(scope.boxClick, {arg: arg});
        };

        scope.clickToBack = function () {
            scope.boxBackToList();
        };

        scope.withClickToBack = function () {
            return !_.isUndefined(attrs.boxBackToList) && (_.isUndefined(attrs.boxBackToListShow) || scope.boxBackToListShow());
        };

        scope.refreshBox = function (args) {
            var response = scope.boxRefresh({args: args});

            if (!_.isUndefined(response)) {
                response.then(function (updBoxModel) {
                    scope.boxModel = updBoxModel;

                    if (_.isUndefined(scope.boxModel)) scope.boxModel = {};

                    return scope.refreshBoxPermissions();
                });
            }
        };
    })
    .controller('BoxTmplController', Controller);

Controller.$inject = ['$rootScope', '$scope', '$modal', 'govNotificationDelay', 'permissionService'];

function Controller($rootScope, $scope, $modal, govNotificationDelay, permissionService) {

    $scope.getInternalTemplateUrl = function (attrs) {

        var tmplName = attrs.boxTmpl;
        if (!_.isUndefined(attrs.boxTmplBehavior)) {
            tmplName += '.' + attrs.boxTmplBehavior;
        }

        return $scope.baseTemplatePath.replace('[Template]', tmplName);
    };

    $scope.ctxtBox = {};
    $scope.boxPermissions = {};
    $scope.govNotificationDelay = govNotificationDelay;

    // By default, always show box content
    $scope.isBoxDisplayed = true;
    $scope.boxClickablePermission = $scope.boxClickablePermission || 'View';
    $scope.boxIfPermission = $scope.boxIfPermission || 'View';

    // inherit authenticatedUser from $rootScope.
    $scope.authenticatedUser = $rootScope.authenticatedUser;

    // Box Refresh
    $scope.$on('need-refresh', function (event, args) {
        $scope.refreshBox(args);
    });

    $scope.pageIsDirty = function () {
        $rootScope.$broadcast('page-is-dirty');
    };

    $scope.pageIsNotDirty = function () {
        $rootScope.$broadcast('page-is-not-dirty');
    };

    $scope.$on('page-is-dirty', function () {
        $scope.setPageDirty(true);
    });

    $scope.$on('page-is-not-dirty', function () {
        $scope.setPageDirty(false);
    });

    $scope.setPageDirty = function (isDirty) {
        $scope.ctxtBox.isDirty = _.isBoolean(isDirty) ? isDirty : true;
    };

    $scope.setPageNotDirty = function () {
        $scope.setPageDirty(false);
    };

    $scope.isPageDirty = function() {
        return $scope.ctxtBox.isDirty === true;
    };

    $scope.confirmClick = function (toClick, argsToClick) {
        if ($rootScope.isShowingModal) return;

        if ($scope.ctxtBox.isDirty === true) {

            $rootScope.isShowingModal = true;

            var modalScope = $rootScope.$new();

            var confirmModal = $modal({
                scope: modalScope,
                show: true,
                template: '/app/shared/boxTemplate/boxConfirmWhenDirtyPage.tpl.html',
                placement: 'center'
            });

            modalScope.hideModal = function () {
                confirmModal.$promise.then(confirmModal.hide);
            };

            modalScope.$on('modal.hide', function () {
                $rootScope.isShowingModal = false;
            });

            modalScope.ok = function () {
                modalScope.hideModal();
                toClick.call(this, argsToClick);
            }
        } else {
            toClick.call(this, argsToClick);
        }
    };

    $scope.refreshBoxPermissions = function () {
        $scope.boxModelPermission = angular.isUndefined($scope.boxModelPermission) ? $scope.boxModel : $scope.boxModelPermission;
        $scope.boxPermissions = permissionService.getPermissions($scope.boxFeatureRole, $scope.boxPermissionKey, $scope.boxModelPermission);

        // show or hide box based on boxIfPermission and boxFeatureRole.
        if ($scope.boxIfPermission !== 'true' && $scope.boxFeatureRole) {
            // when boxModel contains a list of items, look into all items for permissions.
            var boxModels = angular.isArray($scope.boxModelPermission) ? $scope.boxModelPermission : [$scope.boxModelPermission];
            if (!boxModels.length) { boxModels = [null]; }

            // TODO:
            // This has been removed (forced to true), but we should use the boxmodel correctly which is to make sure
            // for each boxModel that the isBoxDisplayed is true based on the correct permissions.
            // By default it uses the 'View' permission on the current BoxModel, but can be overwritten using
            //      boxFeatureRole
            //      boxModelPermission
            //      boxPermissionKey
            $scope.isBoxDisplayed = boxModels.some(function (boxModelPermission) {
                return true; //permissionService.hasPermission($scope.boxFeatureRole, $scope.boxPermissionKey, $scope.boxIfPermission, boxModelPermission);
            });
        }

    	// if boxFeatureRole is defined, boxClickablePermission permission should exist. Otherwise box should be defined as clickable explicitly
        if ($scope.boxClickable === 'true') {
	        $scope.isBoxClickable = true;
        }
        else if ($scope.boxFeatureRole) {
            $scope.isBoxClickable = !!$scope.boxPermissions[$scope.boxClickablePermission] && !($scope.boxClickable === 'false');
        } else {
            $scope.isBoxClickable = !($scope.boxClickable === 'false');
        }
    };

    $scope.refreshBoxPermissions();
}
})();